import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";

import { LanguageModule } from "@intocare/language";

import { IcFormsModule } from "./../../core/ic-forms.module";

@Component({
	selector: "custom-form-number",
	imports: [CommonModule, IcFormsModule, LanguageModule, ReactiveFormsModule],
	template: `
		<div class="dynamic-field form-number" [formGroup]="group">
			<ic-form-field>
				<span icLabel><ng-content select="h3" /></span>

				<input
					icInput
					type="number"
					[formControlName]="config.name"
					[max]="config.max"
					[min]="config.min"
					[pattern]="config.pattern"
					[placeholder]="placeholder | language"
				/>

				@if (config.suffix && config.suffix.type === "icon") {
					<span class="suffix suffix-icon" icSuffix [ngClass]="config.suffix.value"> </span>
				}

				@if (config.suffix && config.suffix.type === "text") {
					<span class="suffix suffix-text" icSuffix>
						{{ config.suffix.value | language }}
					</span>
				}
			</ic-form-field>
		</div>
	`,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormNumberComponent {
	@Input() config: any;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
